import {TranslationKeyForkygram} from '../../keys'
import {TranslationResource} from '../../TranslationType'

export const TRANSLATION_FORKYGRAM_ID: TranslationResource<TranslationKeyForkygram> = {
  translation: {
    'forkygram:accountUnavailable': 'Akun ini tidak tersedia',
    'forkygram:authAccessHeader': 'Masuk',
    'forkygram:beingBlocked': 'Belum ada postingan yang diunggah di sini.',
    'forkygram:blockYuser': 'Blokir Yuser',
    'forkygram:blockYuserAcc': 'Blokir Akun Yuser',
    'forkygram:blockYuserAccSuccess': 'Akun berhasil diblokir',
    'forkygram:blockYuserAccText':
      'Apakah kamu yakin ingin memblokir akun pengguna?',
    'forkygram:blockedDescription':
      'Kamu tidak dapat melihat foto atau video karena kamu telah memblokir yuser ini.',
    'forkygram:caption': 'Keterangan',
    'forkygram:captionInputPlaceholder':
      'Masukkan keterangan di sini (Maks. 300 karakter)',
    'forkygram:clearSearch': 'Hapus semua pencarian terkini?',
    'forkygram:commentHeader': 'Komentar ({{comment_count}})',
    'forkygram:commentHeader_plural': 'Komentar ({{comment_count}})',
    'forkygram:commentLimitPerDay':
      'Maaf! Kamu hanya bisa memberi {{comment_limit}} komentar/hari.',
    'forkygram:commentPlaceholder': 'Komentar sebagai {{username}}',
    'forkygram:commentPlaceholder_GUEST':
      'Mohon lakukan login atau pendaftaran untuk meninggalkan komentar.',
    'forkygram:count': '{{count}}',
    'forkygram:count_B': '{{count}}M',
    'forkygram:count_K': '{{count}}RB',
    'forkygram:count_M': '{{count}}JT',
    'forkygram:countUploadDuration': '{{count}} detik lalu',
    'forkygram:countUploadDuration_day': '{{count}} hari lalu',
    'forkygram:countUploadDuration_hour': '{{count}} jam lalu',
    'forkygram:countUploadDuration_minute': '{{count}} menit lalu',
    'forkygram:deletePostComment': 'Hapus Komentar',
    'forkygram:deletePostCommentMessage':
      'Apakah kamu yakin ingin menghapus komentar ini?',
    'forkygram:deletePostMessage':
      'Apakah kamu yakin ingin menghapus postingan ini?',
    'forkygram:deletePostTitle': 'Hapus Postingan',
    'forkygram:emptyFeedMessage':
      'Tidak ada konten yang dapat ditampilkan sekarang',
    'forkygram:emptyFeedTitle': 'Ups, sepertinya kamu telah melihat semuanya!',
    'forkygram:feedTabTitle': 'Feed',
    'forkygram:feedTabTitle_following': 'Mengikuti',
    'forkygram:feedTabTitle_fyp': 'ForYu',
    'forkygram:feedTabTitle_ugc': 'Dibuat Pengguna',
    'forkygram:follow': 'Ikuti',
    'forkygram:followBack': 'Ikuti Balik',
    'forkygram:followRequest': 'Permintaan Mengikuti',
    'forkygram:followRequestEmptyDescription':
      'Orang yang meminta untuk mengikuti kamu akan muncul di sini.',
    'forkygram:followRequestEmptyTitle':
      'Tidak ada permintaan mengikuti saat ini.',
    'forkygram:followerCount': '<follow>{{follow}}</follow> Pengikut',
    'forkygram:followerCount_plural': '<follow>{{follow}}</follow> Pengikut',
    'forkygram:followers': 'Pengikut',
    'forkygram:following': 'Mengikuti',
    'forkygram:followingCount': '<follow>{{follow}}</follow> Mengikuti',
    'forkygram:fototreeTagMismatch': 'Mohon pilih FotoTree dari daftar.',
    'forkygram:fototreeTagNotFound':
      'Kami tidak dapat menemukan FotoTree {{tag_name}}',
    'forkygram:home': 'Beranda',
    'forkygram:hideReply': 'Sembunyikan balasan',
    'forkygram:likes': 'Suka',
    'forkygram:likeLimitPerDay':
      'Maaf! Kamu hanya bisa menyukai 1000 postingan/hari',
    'forkygram:likeLimitPerHour':
      'Maaf! Kamu hanya bisa menyukai 350 postingan/jam.',
    'forkygram:logOutMessage': 'Apakah kamu yakin ingin keluar?',
    'forkygram:message': 'Pesan',
    'forkygram:myAccount': 'Akun Saya',
    'forkygram:noPost': 'Belum ada postingan',
    'forkygram:noPostDescription':
      'Yuser ini belum mempublikasikan apa pun di sini',
    'forkygram:post': 'Postingan',
    'forkygram:postDelete': 'Hapus postingan',
    'forkygram:postEdit': 'Sunting postingan',
    'forkygram:postEmptyButton': 'Unggah Sekarang',
    'forkygram:postEmptyDescription':
      'Kamu belum mengunggah momenmu. Kami bersemangat untuk momen kamu yang mengagumkan.',
    'forkygram:postEmptyHeader': 'Momen Kamu',
    'forkygram:postPin': 'Pin postingan',
    'forkygram:postPinFailed': 'Maksimal konten yang bisa di-pin adalah 9.',
    'forkygram:postPinSuccess': 'Postingan telah di-pin ke profil kamu.',
    'forkygram:postShare': 'Bagikan postingan',
    'forkygram:postUnpin': 'Unpin postingan',
    'forkygram:postUnpinSuccess':
      'Postingan yang di-pin telah dilepas dari profil kamu.',
    'forkygram:postUpdated': 'Postingan Diperbaharui',
    'forkygram:privateAccount': 'Akun ini bersifat privat',
    'forkygram:privateAccountDescription':
      'Ikuti akun ini untuk melihat aktivitasnya.',
    'forkygram:removeFollower': 'Hapus',
    'forkygram:removeFollowerDescription':
      '<username>@{{username}}</username> tidak akan diberi tahu bahwa kamu menghapus dia dari pengikut kamu.',
    'forkygram:removeFollowerSuccess': 'Pengikut berhasil dihapus.',
    'forkygram:removeFollowerTitle': 'Hapus Pengikut?',
    'forkygram:reply': 'Balas',
    'forkygram:replying': 'Membalas',
    'forkygram:reportCancel': 'Laporan dibatalkan.',
    'forkygram:reportComment': 'Laporkan Komentar',
    'forkygram:reportComment_HATE SPEECH': 'Ujaran kebencian',
    'forkygram:reportComment_HARASSMENT': 'Perundungan atau pelecehan',
    'forkygram:reportComment_HARRASMENT': 'Perundungan atau pelecehan',
    'forkygram:reportComment_OTHER': 'Isu lainnya',
    'forkygram:reportComment_SPAM': 'Komentar spam',
    'forkygram:reportCommentAlreadyReported':
      'Kamu sudah melaporkan komentar ini.',
    'forkygram:reportCommentCancel': 'Laporan dibatalkan.',
    'forkygram:reportCommentFailed': 'Ada masalah saat melaporkan komentar..',
    'forkygram:reportCommentSuccess':
      'Terima Kasih telah melaporkan. Komentar telah berhasil dilaporkan.',
    'forkygram:reportOtherPlaceholder': 'Tulis alasanmu disini...',
    'forkygram:reportPostFailed': 'Ada masalah saat melaporkan postingan.',
    'forkygram:reportPostSuccess':
      'Terima kasih telah melaporkan. Postingan telah berhasil dilaporkan.',
    'forkygram:reportYuser': 'Laporkan Yuser',
    'forkygram:reportYuserFailed': 'Ada masalah saat melaporkan akun ini.',
    'forkygram:reportYuserReason': 'Tidak diketahui',
    'forkygram:reportYuserReason_FAKE ACCOUNT':
      'Berpura-pura menjadi orang lain',
    'forkygram:reportYuserReason_INAPPROPRIATE':
      'Salah satu konten yang diunggah seharusnya tidak diperbolehkan',
    'forkygram:reportYuserReason_OTHER': 'Lainnya',
    'forkygram:reportYuserSuccess':
      'Terima kasih telah melaporkan akun ini. Akun berhasil dilaporkan.',
    'forkygram:searchFriends': 'Temukan Teman',
    'forkygram:searchFriendsNotFound':
      'Maaf! Kami tidak dapat menemukan pengguna yang kamu cari',
    'forkygram:searchFriendsNotFoundSubtitle':
      'Silakan coba lagi menggunakan kata kunci lain.',
    'forkygram:shareYuser': 'Bagikan Yuser',
    'forkygram:unblock': 'Buka Blokir',
    'forkygram:unblockConfirmation':
      'Apakah kamu yakin untuk membuka blokir akun ini?',
    'forkygram:unblockSuccessMessage': 'Buka blokir akun berhasil',
    'forkygram:unblockYuser': 'Buka Blokir Yuser',
    'forkygram:unfollowDescription':
      'Kamu perlu mengirimkan permintaan mengikuti lagi untuk mendapatkan akses kembali.',
    'forkygram:unfollowTitle': 'Berhenti Mengikuti Akun Privat Ini?',
    'forkygram:uploadEditThumbnail': 'Edit Thumbnail',
    'forkygram:uploadEditThumbnail_select': 'Pilih Thumbnail',
    'forkygram:uploadEditThumbnail_upload': 'Unggah Thumbnail',
    'forkygram:uploadEditThumbnailUploadNew': 'Unggah Thumbnail Baru',
    'forkygram:uploadEditThumbnailUploadValidation': '',
    'forkygram:uploadEditThumbnailUploadValidation_1':
      'JPG, JPEG, PNG, HEIC, HEIF',
    'forkygram:uploadEditThumbnailUploadValidation_2':
      'Ukuran Maksimum {{size}} MB',
    'forkygram:uploadEditThumbnailUploadValidation_3':
      'Resolusi Minimum {{width}}x{{height}} piksel',
    'forkygram:uploadHeader': 'Info Konten',
    'forkygram:uploadInvalidImageFormat':
      'File gambar tidak sesuai atau tidak diperbolehkan. Hanya file dengan ekstensi berikut yang diperbolehkan: jpg, jpeg, png, heic, dan heif',
    'forkygram:uploadInvalidVideoFormat':
      'File video tidak sesuai atau tidak diperbolehkan. Hanya file dengan ekstensi berikut yang diperbolehkan: mp4(mpeg-4), dan mov',
    'forkygram:uploadLimitMessage':
      'Kamu telah mencapai batas jumlah posting. Coba kembali setelah {{value}} {{unit}}.',
    'forkygram:uploadLimitMessage_leaf':
      'Kamu telah mencapai batas jumlah daun. Coba kembali setelah {{value}} {{unit}}.',
    'forkygram:uploadMaxImageResolutionMessage':
      'Resolusi maksimum gambar adalah 25 megapixels',
    'forkygram:uploadMaxImageSizeMessage': 'Ukuran maksimum gambar adalah 5 MB',
    'forkygram:uploadMaxVideoDurationMessage':
      'Durasi maksimum video adalah 30 detik',
    'forkygram:uploadMaxVideoSizeMessage': 'Ukuran maksimum video adalah 30 MB',
    'forkygram:uploadMaxVideoWidthMessage':
      'Lebar maksimum video adalah 1080 pixels',
    'forkygram:uploadMinImageResolutionMessage':
      'Resolusi minimum gambar adalah 600x600 pixel',
    'forkygram:uploadPostActivateRoboyuBottomDesc':
      'Saat RoboYu kamu telah aktif, kamu dapat kembali ke sini untuk mulai mengunggah konten kamu.',
    'forkygram:uploadPostActivateRoboyuUpperDesc':
      'Kamu harus mengaktifkan RoboYu terlebih dahulu sebelum mengunggah konten pertama kamu.',
    'forkygram:uploadSearchPeoplePlaceholder': 'Cari berdasarkan username',
    'forkygram:uploadSuccessMessage': 'Selamat! Gambar telah berhasil diunggah',
    'forkygram:uploadSuccessMessage_leaf':
      'Kamu telah meninggalkan selembar daun kenangan.',
    'forkygram:uploadThumbnailFailed': 'Gagal mengunggah thumbnail.',
    'forkygram:viewReply': 'Tampilkan {{count}} balasan',
    'forkygram:viewReply_plural': 'Tampilkan {{count}} balasan',
  },
}
